import R from 'ramda';

import getModalsLogic from './getModalsLogic';

export default R.curry((modalName, state) =>
  R.propEq('openModal', modalName, getModalsLogic(state)),
);
